import { FC } from "react";
import { useTranslation, Trans } from "react-i18next";
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import { ButtonsWrapper, Wrapper } from "./styles";

interface IConfirmDeleteModal {
  visible: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal: FC<IConfirmDeleteModal> = ({
  visible,
  loading,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('disciplinas');

  const footerConfirmButtons = (
    <ButtonsWrapper>
      <Button
        className="cancel"
        loading={loading}
        disabled={loading}
        onClick={onConfirm}
      >
        <span className="cancelText">{t('confirmDeleteModal.confirmDelete')}</span>
      </Button>
      <Button
        type="primary"
        className="confirm"
        onClick={onCancel}
      >
        <span className="confirmText">{t('confirmDeleteModal.cancel')}</span>
      </Button>
    </ButtonsWrapper>
  );

  return (
    <Modal
      title={t('confirmDeleteModal.modalTitle')}
      visible={visible}
      onCancel={onCancel}
      footerButtons={footerConfirmButtons}
      width={487}
    >
      <Wrapper>
        <span className="description">
          <Trans
            i18nKey="confirmDeleteModal.description"
            ns="disciplinas"
            components={{ bold: <b /> }}
          />
        </span>
      </Wrapper>
    </Modal>
  )
}

export default ConfirmDeleteModal;
